import { itemPriceService } from '../../helpers/services/itemPrice.service'
import i18n from '@/i18n'
import { sharedHelper } from '@/utils'

export const state = {
  list: { data: [], pagination: { pageNumber: 0, pageSize: 0, lastPage: 0, tableRowsCount: 0 } },
  byItem: [],
  status: { list: true, detail: true, save: true },
}

export const ITEM_PRICE_MODULE = 'itemPrice'

export const GET_ALL_ITEM_PRICES = 'getAllItemPrices'
export const GET_ITEM_PRICE_BY_ITEM = 'getItemPriceByItem'
export const CREATE_ITEM_PRICE = 'createItemPrice'

const REQUESTING = 'requesting'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'
const LIST_SUCCESS = 'listSuccess'
const BY_ITEM_SUCCESS = 'byItemSuccess'

function mapRow(item) {
  return {
    itemCode: item.item_code,
    uom: item.uom,
    price: item.price,
    barCode: item.bar_code,
    cost: item.cost,
    minSalePrice: item.min_sale_price,
    maxSalePrice: item.max_sale_price,
    reorderLevel: item.reorder_level,
    reorderQty: item.reorder_qty,
  }
}

export const actions = {
  [GET_ALL_ITEM_PRICES]({ commit }, { filter }) {
    commit(REQUESTING, 'list')
    itemPriceService.getAllItemPrices(filter).then((r) => {
      commit(LIST_SUCCESS, r); commit(SUCCESS)
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [GET_ITEM_PRICE_BY_ITEM]({ commit }, { itemCode }) {
    commit(REQUESTING, 'detail')
    return itemPriceService.getItemPriceByItem(itemCode).then((r) => {
      commit(BY_ITEM_SUCCESS, r); commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [CREATE_ITEM_PRICE]({ commit, dispatch }, { data, filter }) {
    commit(REQUESTING, 'save')
    return itemPriceService.createItemPrice(data).then((r) => {
      sharedHelper.alertSuccessMessage(i18n.t('label.createX', [i18n.t('module.itemPrice')]))
      commit(SUCCESS); if (filter) dispatch(GET_ALL_ITEM_PRICES, { filter }); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
}

export const mutations = {
  [LIST_SUCCESS](state, data) {
    const items = data.data || []
    state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)
    state.list.data = data.success ? items.map(mapRow) : items
  },
  [BY_ITEM_SUCCESS](state, data) {
    state.byItem = (data.data || []).map(mapRow)
  },
  [FAILURE](state) { state.status = { list: true, detail: true, save: true } },
  [REQUESTING](state, type) { state.status[type] = false },
  [SUCCESS](state) { state.status = { list: true, detail: true, save: true } },
}
